/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { BsController } from "react-icons/bs";
import { FaBriefcase, FaHeart, FaTicketAlt, FaWpforms } from "react-icons/fa";
import { FiBell, FiCamera, FiHeadphones, FiLogOut, FiMail, FiMapPin, FiPhone, FiRefreshCcw, FiSearch, FiShield, FiStar, FiUser } from "react-icons/fi";
import { HiOutlineFilm, HiOutlineHome } from "react-icons/hi2";
import { MdOutlineAccountBalanceWallet, MdOutlineApps, MdOutlineEvent, MdOutlineLocalOffer, MdOutlineShoppingBag, MdOutlineSportsCricket } from "react-icons/md";
import { MyContext } from "../../Context/MyProvider";
import Dphoto from "../../Images/profile-default.png";
import logoWithName from "../../Images/logowithname.png";
import { showTost } from "../../showTost";
import DesktopUserChip from "./DesktopUserChip";
import { isUserLoggedIn, logoutUser, requireLogin } from "../../utils/auth";
import { arrangeSidebarMenuItems } from "../../utils/sidebarMenu";

const emptyProfile = {
  loginId: "",
  name: "",
  email: "",
  mobileNo: "",
  referralCode: "",
  referralCount: 0,
};

const Profile = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setIsLoginShow, setIsLogin, setIsShowBtn } = useContext(MyContext);

  const [data, setData] = useState(emptyProfile);
  const [profilePic, setProfilePic] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [isShow, setIsShow] = useState(false);
  const [loading, setLoading] = useState(true);

  const inputRef = useRef();
  const loginId = localStorage.getItem("Userid");

  useEffect(() => {
    document.body.classList.add("desktop-home-active");
    return () => {
      document.body.classList.remove("desktop-home-active");
    };
  }, []);

  useEffect(() => {
    const handleProfileData = async () => {
      if (!loginId) {
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const res = await axios.get(`https://yblapis.ganpatigroupbharat.com/api/auth/getuserdetailByLoginId?loginId=${loginId}`);

        if (res.data?.isSuccess === true) {
          const userData = res.data?.data || {};

          setData({
            loginId,
            name: userData.name || "",
            email: userData.email || "",
            mobileNo: userData.mobileNo || "",
            referralCode: userData.referralCode || "",
            referralCount: userData.referralCount || 0,
          });

          if (userData.imagePath) {
            setProfilePic(`https://yblapis.ganpatigroupbharat.com/${userData.imagePath}`);
          }
        }
      } catch (error) {
        showTost("Server error", "error");
      } finally {
        setLoading(false);
      }
    };

    handleProfileData();
  }, [loginId]);

  const profileMenuItems = [
    { label: "Home", icon: HiOutlineHome, path: "/" },
    { label: "Movies", icon: HiOutlineFilm },
    { label: "Events", icon: MdOutlineEvent, path: "/events" },
    { label: "Sports", icon: MdOutlineSportsCricket },
    { label: "Games", icon: BsController },
    { label: "Shopping", icon: MdOutlineShoppingBag, externalUrl: "https://shop.nabhiverse.com/" },
    { label: "Services", icon: MdOutlineApps },
    { label: "Offers", icon: MdOutlineLocalOffer },
    { label: "Bookings", icon: FaTicketAlt, path: "/booking" },
    { label: "Favorites", icon: FaHeart, path: "/favorite" },
    { label: "eWallet", icon: MdOutlineAccountBalanceWallet, path: "/wallet" },
    { label: "Forms", icon: FaWpforms, path: "/form-list" },
    { label: "Business", icon: FaBriefcase, path: "/business-user" },
    { label: "Profile", icon: FiUser, path: "/profile", active: true },
    { label: "Logout", icon: FiLogOut, action: "logout" },
  ];

  const mobileBottomMenuItems = [
    { label: "Home", icon: HiOutlineHome, path: "/" },
    { label: "Forms", icon: FaWpforms, path: "/form-list" },
    { label: "Account", icon: FiUser, path: "/profile", active: true },
    { label: "Business", icon: FaBriefcase, path: "/business-user" },
  ];

  const handleMenuClick = async (item) => {
    if (item.externalUrl) {
      if (!requireLogin(setIsLoginShow)) return;

      window.location.href = item.externalUrl;
      return;
    }

    if (item.action === "logout") {
      const didLogout = await logoutUser({ navigate, setIsLogin, setIsShowBtn });

      if (didLogout) {
        showTost("Logout successfully !!", "success");
      }

      return;
    }

    if (item.path) {
      navigate(item.path);
    }
  };
  const shouldShowMenuItem = (item) =>
    !["Bookings", "Favorites", "eWallet", "Logout"].includes(item.label) ||
    isUserLoggedIn();

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];

    if (file) {
      setSelectedFile(file);
      setProfilePic(URL.createObjectURL(file));
    }
  };

  const handleAddPhoto = async () => {
    if (!loginId) {
      setIsLoginShow(true);
      setIsShow(false);
      return;
    }

    if (!selectedFile) {
      showTost("Please select image", "error");
      return;
    }

    const formData = new FormData();
    formData.append("loginId", data.loginId);
    formData.append("name", data.name);
    formData.append("emailId", data.email);
    formData.append("mobileNo", data.mobileNo);
    formData.append("file", selectedFile);

    try {
      const res = await axios.post(
        "https://yblapis.ganpatigroupbharat.com/api/auth/updateprofilebyloginid",
        formData
      );

      if (res.data?.status === true) {
        showTost("Profile image updated", "success");
        setIsShow(false);
        setSelectedFile(null);
      } else {
        showTost("Image upload failed", "error");
      }
    } catch (error) {
      showTost("Server error", "error");
    }
  };

  const renderSidebar = () => (
    <aside className="desktop_home_sidebar">
      <div className="desktop_home_logo">
        <img src={logoWithName} alt="Nabhiverse" />
      </div>
      <nav className="desktop_home_nav">
        {arrangeSidebarMenuItems(profileMenuItems).filter(shouldShowMenuItem).map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.label}
              className={`desktop_home_nav_item ${item.active ? "active" : ""}`}
              type="button"
              onClick={() => handleMenuClick(item)}
            >
              <Icon />
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>
      <div className="desktop_home_star_box">
        <FiStar />
        <span>nabi star</span>
        <strong>Your Stars 620</strong>
        <button type="button">View Benefits</button>
      </div>
      <div className="desktop_home_help_box">
        <FiHeadphones />
        <span>Need Help?</span>
        <p>24x7 Support</p>
        <button type="button">Contact Us</button>
      </div>
    </aside>
  );

  return (
    <div className="nabhiverse_desktop_home profile_layout">
      {renderSidebar()}

      <main className="desktop_home_main profile_main">
        <header className="desktop_home_topbar profile_topbar">
          <div className="mobile_header_logo">
            <img src={logoWithName} alt="Nabhiverse" />
          </div>
          <div className="desktop_search_box">
            <FiSearch />
            <input
              type="text"
              placeholder="Search for apps, services, movies, events and more..."
              readOnly
            />
          </div>
          <div className="desktop_location"><FiMapPin /> Bengaluru</div>
          <DesktopUserChip />
          <button className="desktop_bell_btn" type="button" aria-label="Notifications">
            <FiBell />
            <span>3</span>
          </button>
        </header>

        <section className="profile_shell">
          <div className="profile_hero">
            <div>
              <span className="profile_eyebrow">NabhiVerse Account</span>
              <h1>{t("My Profile")}</h1>
              <p>Manage your account identity, referral details, and profile photo from one clean dashboard.</p>
            </div>
            <div className="profile_referral_card">
              <span>Referral Code</span>
              <strong>{data.referralCode || "N/A"}</strong>
              <small>{data.referralCount || 0} referrals joined</small>
            </div>
          </div>

          {!loginId ? (
            <div className="profile_empty">
              <FiUser />
              <h2>{t("Login required")}</h2>
              <p>Please login to view and update your profile details.</p>
              <button type="button" onClick={() => setIsLoginShow(true)}>Login</button>
            </div>
          ) : (
            <div className="profile_content_grid">
              <div className="profile_card profile_identity_card">
                <div className="profile_avatar_wrap">
                  <img src={profilePic || Dphoto} alt="" />
                  <button type="button" onClick={() => setIsShow(true)} aria-label="Update profile photo">
                    <FiCamera />
                  </button>
                </div>
                <h2>{data.name || "User"}</h2>
                <p>{data.email || "Email not available"}</p>
                <div className="profile_quick_stats">
                  <div>
                    <span>Login ID</span>
                    <strong>{data.loginId || "--"}</strong>
                  </div>
                  <div>
                    <span>Referrals</span>
                    <strong>{data.referralCount || 0}</strong>
                  </div>
                </div>
              </div>

              <div className="profile_card profile_details_card">
                <div className="profile_card_head">
                  <span>Personal Details</span>
                  <strong>Read only</strong>
                </div>

                {loading ? (
                  <div className="profile_loading">Loading profile...</div>
                ) : (
                  <div className="profile_fields_grid">
                    <label>
                      <span>Full Name</span>
                      <div><FiUser />{data.name || "--"}</div>
                    </label>
                    <label>
                      <span>Email Address</span>
                      <div><FiMail />{data.email || "--"}</div>
                    </label>
                    <label>
                      <span>Mobile Number</span>
                      <div><FiPhone />{data.mobileNo || "--"}</div>
                    </label>
                    <label>
                      <span>Referral Code</span>
                      <div><FiStar />{data.referralCode || "N/A"}</div>
                    </label>
                  </div>
                )}
              </div>
            </div>
          )}
        </section>

        <footer className="desktop_home_footer profile_footer">
          <img src={logoWithName} alt="Nabhiverse" />
          <span><FiShield /> Fast & Secure Payments</span>
          <span><FiRefreshCcw /> Easy Returns</span>
          <span><FiHeadphones /> 24x7 Support</span>
          <p>(c) 2026 Nabhiverse. All Rights Reserved.</p>
        </footer>
      </main>

      <nav className="mobile_bottom_menu">
        {mobileBottomMenuItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.label}
              type="button"
              className={item.active ? "active" : ""}
              onClick={() => handleMenuClick(item)}
            >
              <Icon />
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>

      {isShow && (
        <div onClick={() => setIsShow(false)} className="profile_upload_overlay">
          <div onClick={(e) => e.stopPropagation()} className="profile_upload_modal">
            <button type="button" className="profile_upload_preview" onClick={() => inputRef.current.click()}>
              <img src={profilePic || Dphoto} alt="" />
              <span><FiCamera /> Choose Photo</span>
            </button>
            <input ref={inputRef} onChange={handleImageChange} className="hidden" type="file" accept="image/*" />
            <h3>{t("Add Your Favorite Photo")}</h3>
            <p>Select a clear image for your Nabhiverse profile.</p>
            <div className="profile_upload_actions">
              <button type="button" onClick={() => setIsShow(false)}>Cancel</button>
              <button type="button" onClick={handleAddPhoto}>Upload</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;
/* jshint ignore:end */
